export default class Question {

    /**
     * @param id: string
     * @param question: string
     * @param image: string|null
     * @param answers: Answer[]
     * @param topicId: string
     * @param subjectId: string
     */
    constructor(
        id,
        question,
        image,
        answers,
        topicId,
        subjectId
    ) {
        this.id = id;
        this.question = question;
        this.image = image;
        this.topicId = topicId;
        this.subjectId = subjectId;
        this.answers = answers.filter(answer => answer.answer);
    }
}